var render = function render(){var _vm=this,_c=_vm._self._c;return _c('survey-send-invitations',{attrs:{"title":"label_violenceSurvey_sendToStaff_title","background-color":"#f5fafd","template-id":"ViolenceSurvey","management-route":"violence-survey"}})
}
var staticRenderFns = []

export { render, staticRenderFns }